import { useEffect, useState } from "react";
import axios from "axios";
import { isNativeApp } from "../utils/tapToPay";

const API = process.env.REACT_APP_BACKEND_URL;
const _cache = {}; // kind -> status payload

export const refreshTTPStatus = (kind) => { delete _cache[kind]; };

/** Tap to Pay status for the current user. `native` is true only inside the
 *  mobile shell (the only place the NFC hardware is reachable). */
export const useTapToPayStatus = (kind = "owner") => {
  const native = isNativeApp();
  const [status, setStatus] = useState(() => _cache[kind] || null);

  useEffect(() => {
    if (!native) return;
    if (_cache[kind]) { setStatus(_cache[kind]); return; }
    const url = kind === "tech" ? `${API}/api/tech/terminal/status` : `${API}/api/terminal/status`;
    const tok = localStorage.getItem(kind === "tech" ? "tech_token" : "token");
    if (!tok) return;
    axios.get(url, { headers: { Authorization: `Bearer ${tok}` } })
      .then((r) => { _cache[kind] = r.data; setStatus(r.data); })
      .catch(() => {});
  }, [kind, native]);

  return { native, status, eligible: native && !!status?.eligible };
};

export const useTapToPayEligible = (kind = "owner") => useTapToPayStatus(kind).eligible;
